import { NgClass } from "@angular/common";
import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Router, RouterLink, RouterLinkActive } from "@angular/router";
import { IconModule } from "@los-workspace/common-lib";
import { Store } from "@ngrx/store";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { NgScrollbarModule } from "ngx-scrollbar";
import { STAFF_MODULE } from "../core/permissions/permission.constants";
import { HasModuleDirective } from "../core/permissions/has-module.directive";
import { OpportunityWorkflowBridge } from "../pages/opportunities/services/opportunity-workflow.bridge";

@Component({
  selector: "sidebar",
  templateUrl: "./sidebar.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgClass,
    RouterLink,
    NgScrollbarModule,
    RouterLinkActive,
    TranslateModule,
    IconModule,
    HasModuleDirective,
  ],
})
export class SidebarComponent implements OnInit {
  readonly staffModule = STAFF_MODULE;
  active = false;
  store: any;
  activeDropdown: string[] = [];
  parentDropdown: string = "";
  private readonly opportunityWorkflow = inject(OpportunityWorkflowBridge);

  constructor(
    public readonly translate: TranslateService,
    public readonly storeData: Store<any>,
    public readonly router: Router,
  ) {}

  ngOnInit() {
    this.initStore();
    this.setActiveDropdown();
  }

  async initStore() {
    this.storeData
      .select((d) => d.index)
      .subscribe((d) => {
        this.store = d;
      });
  }

  setActiveDropdown() {
    const selector = document.querySelector(
      '.sidebar ul a[routerLink="' + window.location.pathname + '"]',
    );
    if (selector) {
      selector.classList.add("active");
      const ul: any = selector.closest("ul.sub-menu");
      if (ul) {
        let ele: any =
          ul.closest("li.menu").querySelectorAll(".nav-link") || [];
        if (ele.length) {
          ele = ele[0];
          setTimeout(() => {
            ele.click();
          });
        }
      }
    }
  }

  toggleMobileMenu() {
    if (window.innerWidth < 1024) {
      this.storeData.dispatch({ type: "toggleSidebar" });
    }
  }

  /** Reset Opportunities shell to list when OPPORTUNITY is clicked while already on /opportunities. */
  onOpportunitySidebarClick(event: MouseEvent): void {
    this.toggleMobileMenu();
    const path = this.router.url.split("?")[0];
    if (path === "/opportunities" || path.startsWith("/opportunities/")) {
      event.preventDefault();
      void this.opportunityWorkflow.returnToModuleList();
    }
  }

  /** Drop paused Opportunity workflow when navigating to another top-level module. */
  onLeaveOpportunitiesModule(): void {
    const path = this.router.url.split("?")[0];
    if (path === "/opportunities" || path.startsWith("/opportunities/")) {
      void this.opportunityWorkflow.leaveModule();
    }
    this.toggleMobileMenu();
  }

  toggleAccordion(name: string, parent?: string) {
    if (this.activeDropdown.includes(name)) {
      this.activeDropdown = this.activeDropdown.filter((d) => d !== name);
    } else {
      this.activeDropdown.push(name);
    }
  }
}
